import { useMutation } from "@/compat/reactQuery";
import templateFormService from "../../services/templateFormService";

const useAddFormComment = () => useMutation(templateFormService.addFormComment)

export default useAddFormComment;